import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import { Link } from "react-router-dom";
import { getitemLevelInformationByItem } from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";

class ViewItemInformationItemLevel extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item) {
      var item = this.state.lookup.item;
      getitemLevelInformationByItem(item).then(res => {
        this.setTransitioMessage("");
        var data = [];

        if (res.data.success) {
          data = res.data.data;
        } else {
          data = false;
          this.setErrorMessage("Nothing found.");
        }
        this.setState({ data });
        this.setState({
          header: [
            { label: "Item", name: "itemNumber" },
            {
              label: "Description",
              name: "description",
              value: data === false ? " " : data.description
            },
            {
              label: "Line",
              name: "lineCode",
              value: data === false ? " " : data.lineCode
            },
            {
              label: "Alt Line",
              name: "altLineCode",
              value: data === false ? " " : data.altLineCode
            },
            {
              label: "Part",
              name: "partNumber",
              value: data === false ? " " : data.partNumber
            },
            {
              label: "Alt Part",
              name: "altPartNumber",
              value: data === false ? " " : data.altPartNumber
            },
            {
              label: "Supercede Part",
              name: "shortDescription",
              value: data === false ? " " : data.shortDescription
            },
            { label: "PM", name: "ic", value: data === false ? " " : data.ic },
            {
              label: "BG",
              name: "buyerGroup",
              value: data === false ? " " : data.buyerGroup
            },
            {
              label: "Relative Item",
              name: "relativeItem",
              value: data === false ? " " : data.relativeItem
            },
            {
              label: "Sub Line Code",
              name: "subLineCode",
              value: data === false ? " " : data.subLineCode
            },
            {
              label: "Size",
              name: "itemSize",
              value: data === false ? " " : data.itemSize
            },
            {
              label: "Unit of Measure",
              name: "unitOfMeasure",
              value: data === false ? " " : data.unitOfMeasure
            },
            {
              label: "Oil Gallons",
              name: "oilGallons",
              value: data === false ? " " : data.oilGallons
            },
            {
              label: "Buyer 6 Category",
              name: "categoryCode",
              value: data === false ? " " : data.categoryCode
            },
            {
              label: "Commercial Pop Code",
              name: "commPop",
              value: data === false ? " " : data.commPop
            },
            {
              label: "Pending Department",
              name: "pendingDept",
              value: data === false ? " " : data.pendingDept
            },
            {
              label: "Date",
              name: "pendingDate",
              value: data === false ? " " : data.pendingDate
            },
            {
              label: "Department",
              name: "majorDept",
              value:
                data === false
                  ? " "
                  : data.majorDept + " - " + data === false
                  ? " "
                  : data.minorDept
            },
            {
              label: "Store Order Pack",
              name: "orderPack",
              value: data === false ? " " : data.orderPack
            },
            {
              label: "Case Flag",
              name: "caseIndicatorFlag",
              value: data === false ? " " : data.caseIndicatorFlag
            },
            {
              label: "EAS Item",
              name: "easItem",
              value: data === false ? " " : data.easItem
            },
            {
              label: "Store Credit Flag",
              name: "storeCreditFlag",
              value: data === false ? " " : data.storeCreditFlag
            },
            {
              label: "Ship Round Factor",
              name: "shipRoundFactor",
              value: data === false ? " " : data.shipRoundFactor
            },
            {
              label: "Cubic Inches",
              name: "unitCubicMeasure",
              value: data === false ? " " : data.unitCubicMeasure
            },
            {
              label: "Item Weight",
              name: "weight",
              value: data === false ? " " : data.weight
            },
            {
              label: "Item Availability",
              name: "vendDist",
              value: data === false ? " " : data.vendDist
            },
            {
              label: "Personal Warranty",
              name: "warranty",
              value: data === false ? " " : data.warranty
            },
            {
              label: "Warranty Months",
              name: "warrantyMonths",
              value: data === false ? " " : data.warrantyMonths
            },
            {
              label: "Employee Discount",
              name: "discountable",
              value: data === false ? " " : data.discountable
            },
            {
              label: "Multi Return Labels",
              name: "multiReturnLbls",
              value: data === false ? " " : data.multiReturnLbls
            },
            {
              label: "Supply Guide: Store",
              name: "storeSupplyGuide",
              value: data === false ? " " : data.storeSupplyGuide
            },
            {
              label: "DC",
              name: "dcSuppGuide",
              value: data === false ? " " : data.dcSuppGuide
            },
            {
              label: "Fixture",
              name: "fixtureSuppGuide",
              value: data === false ? " " : data.fixtureSuppGuide
            },
            {
              label: "Store Inventory Control",
              name: "storeInvCtl",
              value: data === false ? " " : data.storeInvCtl
            },
            {
              label: "Force Quantity",
              name: "qtyForce",
              value: data === false ? " " : data.qtyForce
            },
            {
              label: "Stocking Level",
              name: "stockMMultiple",
              value: data === false ? " " : data.stockMMultiple
            },
            {
              label: "Register Code",
              name: "pkgLabel",
              value: data === false ? " " : data.pkgLabel
            },
            {
              label: "Custom Ind",
              name: "customCode",
              value: data === false ? " " : data.customCode
            },
            {
              label: "Retail Profile Code",
              name: "retlProfile",
              value: data === false ? " " : data.retlProfile
            },
            {
              label: "Max Per Car",
              name: "maxPerCar",
              value: data === false ? " " : data.maxPerCar
            },
            {
              label: "Supply Code",
              name: "supplyCode",
              value: data === false ? " " : data.supplyCode
            },
            {
              label: "Tax Code",
              name: "taxCode",
              value: data === false ? " " : data.taxCode
            },
            {
              label: "ADF",
              name: "adf",
              value: data === false ? " " : data.adf
            },
            {
              label: "Mich Label",
              name: "msiCode",
              value: data === false ? " " : data.msiCode
            },
            {
              label: "Harmonize Code",
              name: "harmonizeCode",
              value: data === false ? " " : data.harmonizeCode
            },
            {
              label: "Harmonize Quantity",
              name: "harmonizedQty",
              value: data === false ? " " : data.harmonizedQty
            },
            {
              label: "Intl Label",
              name: "intlLabel",
              value: data === false ? " " : data.intlLabel
            },
            {
              label: "Change Date",
              name: "changeDate",
              value: data === false ? " " : data.changeDate
            },
            { label: "", name: "TAG", value: data === false ? " " : data.TAG },
            {
              label: "Hazardous Code",
              name: "hazardCode",
              value: data === false ? " " : data.hazardCode
            },
            {
              label: "Disposal Code",
              name: "disposableCode",
              value: data === false ? " " : data.disposableCode
            },
            {
              label: "MSDS Date",
              name: "msdsDate",
              value: data === false ? " " : data.msdsDate
            },
            {
              label: "Flammable Code",
              name: "flammableCode",
              value: data === false ? " " : data.flammableCode
            },
            {
              label: "Recycle Code",
              name: "recycleCode",
              value: data === false ? " " : data.recycleCode
            }
          ]
        });
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setTransitioMessage();
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.itemNumber
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          View Item Information (Item-Level)
        </h3>
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        {/* <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
          checkOrderConstraints={this.checkOrderConstraints}
        /> */}

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Link to="/" className="sub-menu-item-tag">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
            </Link>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}
export default ViewItemInformationItemLevel;
